import React from "react";
import { Button, Space } from "antd";
import { ContactsOutlined, CrownOutlined, ShopOutlined, SoundOutlined, UserAddOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

/**
 * Guided empty state for the registrations page, shown while an event has no guests at all.
 * Weddings get a single "Add Guest" call to action; general events can also add a VIP or jump
 * to the speakers/exhibitors tabs.
 */
const RegistrationsEmptyState = ({
  isWedding,
  used = 0,
  max,
  limitReached,
  primaryColor,
  onAddGuest,
  onImport,
  onAddVip,
  onManageSpeakers,
  onManageExhibitors,
}) => {
  const { t } = useTranslation();
  const prefix = isWedding ? "wedding" : "general";

  return (
    <div style={{ textAlign: "center", padding: "32px 16px" }}>
      <UserAddOutlined style={{ fontSize: 48, color: primaryColor, marginBottom: 16 }} />
      <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
        {t(`eventRegistrations.emptyState.${prefix}Title`)}
      </h3>
      <p style={{ color: "#666", maxWidth: 420, margin: "0 auto 20px" }}>
        {t(`eventRegistrations.emptyState.${prefix}Description`)}
      </p>

      {limitReached ? (
        <p style={{ color: "#d4380d", fontWeight: 500 }}>
          {t("eventRegistrations.emptyState.limitReached", { max })}
        </p>
      ) : (
        <Space wrap style={{ justifyContent: "center" }}>
          <Button
            type="primary"
            size="large"
            icon={<UserAddOutlined />}
            onClick={onAddGuest}
            style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
          >
            {t("eventRegistrations.emptyState.addGuest")}
          </Button>
          {onImport && (
            <Button size="large" icon={<ContactsOutlined />} onClick={onImport}>
              {t("eventRegistrations.import.button")}
            </Button>
          )}
          {onAddVip && (
            <Button size="large" icon={<CrownOutlined />} onClick={onAddVip}>
              {t("eventRegistrations.emptyState.addVip")}
            </Button>
          )}
        </Space>
      )}

      {max != null && (
        <div style={{ marginTop: 12, fontSize: 13, color: "#8c8c8c" }}>
          {t("eventRegistrations.emptyState.invitationsUsed", { used, max })}
        </div>
      )}

      {(onManageSpeakers || onManageExhibitors) && (
        <div style={{ marginTop: 16 }}>
          <Space split="·" wrap style={{ justifyContent: "center" }}>
            {onManageSpeakers && (
              <Button type="link" icon={<SoundOutlined />} onClick={onManageSpeakers}>
                {t("eventRegistrations.emptyState.manageSpeakers")}
              </Button>
            )}
            {onManageExhibitors && (
              <Button type="link" icon={<ShopOutlined />} onClick={onManageExhibitors}>
                {t("eventRegistrations.emptyState.manageExhibitors")}
              </Button>
            )}
          </Space>
        </div>
      )}
    </div>
  );
};

export default RegistrationsEmptyState;
